import { render, staticRenderFns } from "./LandingFooter.vue?vue&type=template&id=77dd3d56&scoped=true&"
import script from "./LandingFooter.vue?vue&type=script&lang=js&"
export * from "./LandingFooter.vue?vue&type=script&lang=js&"
import style0 from "./LandingFooter.vue?vue&type=style&index=0&id=77dd3d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd3d56",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingShare: require('/home/circleci/repo/components/landing/LandingShare.vue').default,Footer: require('/home/circleci/repo/components/Footer.vue').default})
